import type { PaperProps } from '@mui/material';

import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

interface Props extends PaperProps {
  query?: string;
}

const SearchNotFound = ({ query, sx, ...other }: Props) => {
  return query ? (
    <Paper
      sx={{
        textAlign: 'center',
        ...sx,
      }}
      {...other}
    >
      <Typography paragraph variant="h6">
        Not found
      </Typography>

      <Typography variant="body2">
        No results found for &nbsp;
        <strong>&quot;{query}&quot;</strong>.
        <br /> Try checking for typos or using complete words.
      </Typography>
    </Paper>
  ) : (
    <Typography sx={sx} variant="body2">
      Please enter keywords
    </Typography>
  );
};

export default SearchNotFound;
